import { useMutation } from "@tanstack/react-query";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export interface CloneScenarioPayload {
  newName: string;
}

export interface CloneScenarioResponse {
  id: string;
  scenario: string;
}

export async function cloneScenario(
  projectUuid: string, 
  selectedScenarioId: string, 
  label: string,
  payload: CloneScenarioPayload,
  token: string
): Promise<CloneScenarioResponse> {
  const url = `${config.isometricApiUrl}/functional-graph/${projectUuid}/clone-node/${selectedScenarioId}/${label}`;
  try {
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error cloning scenario:", error);
    throw error;
  }
}

export const useCloneScenario = (
  onSettled?: (res: CloneScenarioResponse | undefined, error: Error | null) => void
) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
      projectUuid: string;
      selectedScenarioId: string;
      label: string;
      body: CloneScenarioPayload;
    }) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace('Bearer ', '');
      return cloneScenario(payload.projectUuid, payload.selectedScenarioId, payload.label, payload.body, token);
    },
    onSettled
  });
};